import React from 'react'
import styled from 'styled-components'

const Content = styled.div`
  padding: 5rem 1rem 1rem;
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;
  .grid-cols-ba {
    grid-template-columns: 1fr 1fr 1fr 360px;
    @media (max-width: 960px) {
      grid-template-columns: 1fr;
    }
  }
`

export { Content }
